// "Lists & lookups": the job setup section where a customer uploads their own vendor list and says
// which field is read from it. The desktop's main process wired these six to the engine
// (apps/desktop/src/main/main.ts); the browser did not, so the section rendered, the tables listed
// through `listDataTables`, and nothing a customer did with one did anything — a saved rule
// resolved `undefined` and read as `saved.id`, a preview rendered as an empty list.
//
// The request shapes are the shared ones (`shared/lookup-rules.ts`), which is where CapturePoint
// already keeps "literally what goes onto the engine's stdin", so the two products cannot drift.
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  engineFieldCanMatchColumnRequest,
  engineMeasureRecentReadingsRequest,
  engineSaveLookupRuleRequest,
  engineTestLookupRequest,
  engineValidateLookupRuleRequest,
} from '../shared/lookup-rules';
import type { EngineCall } from './desktop-commands';
import { listImport } from './list-import';

export function lookupCommands(
  call: EngineCall,
): Record<string, (...args: any[]) => Promise<unknown>> {
  return {
    // Choose file: the list travels in the request where the desktop handed over a path (list-import.ts).
    importDataTable: listImport(call),
    previewDataTable: (request: any) =>
      call('preview-data-table', {
        jobId: request.jobId,
        dataTableId: request.dataTableId,
        limit: request.limit,
        offset: request.offset,
      }),
    saveLookupRule: (request: any) =>
      call('save-lookup-rule', engineSaveLookupRuleRequest(request.jobId, request.rule)),
    testLookup: (request: any) => call('test-lookup', engineTestLookupRequest(request)),
    validateLookupRule: (request: any) =>
      call('validate-lookup-rule', engineValidateLookupRuleRequest(request)),
    fieldCanMatchColumn: (request: any) =>
      call('field-can-match-column', engineFieldCanMatchColumnRequest(request)),
    measureRecentReadings: (request: any) =>
      call('measure-recent-readings', engineMeasureRecentReadingsRequest(request)),
  };
}
